// Model-related constants
export const OLLAMA_DEFAULT_TAG = "latest";
export const OLLAMA_DEFAULT_HOST = "localhost:11434";
